<figure>
  <img [src]="foto" [alt]="alt" class="img-fluid" />
</figure>
